// 1. React
import { memo } from "react";

// 2. UI
import { OfferSaleStats } from "ui/modules/finance/pages/offers/components/OfferSaleStats";

import { VehicleOfferStatsCardProps } from "./types";

const VehicleOfferStatsCard: React.FC<VehicleOfferStatsCardProps> = ({
    fleetVehicleDetail,
}) => {
    if (!fleetVehicleDetail.id) return null;

    return <OfferSaleStats vehicleId={fleetVehicleDetail.id} />;
};

export default memo(VehicleOfferStatsCard);